module.exports = __webpack_public_path__ + "static/img/2_4_1.6d58853f.jpg";